import httpMethod from 'services/update2025/httpMethod';
import axios from 'axios';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { Dropdown } from 'primereact/dropdown';
import { Paginator } from 'primereact/paginator';
import { RadioButton } from 'primereact/radiobutton';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dateFormat1 } from 'utils/date';
import { numberWithCommas } from 'utils/formatNumber';
import { TypePaper } from 'utils/paperType';

const option = [
    { value: 1, label: 'Chờ kích hoạt' },
    { value: 2, label: 'Đang hoạt động' },
    { value: 3, label: 'Khoá tạm thời' },
    { value: 4, label: 'Khoá vĩnh viễn' }
];

export const ThongKeSoLieu = () => {
    //! define
    const toast = useRef(null);
    const { t, i18n } = useTranslation(['account-register', 'common']);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;
    let headers = {
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': i18n.language
    };

    const defaultDateSSO = {
        fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date()
    };

    //! state
    const [loading, setLoading] = useState(false);
    const [muc1, setMuc1] = useState(1);
    const [muc2, setMuc2] = useState(1);
    const [dataReport, setDataReport] = useState();
    const [dataPaper, setDataPaper] = useState();
    const [activeTable, setActiveTable] = useState();
    const [activeStatus, setActiveStatus] = useState(1);
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [valueRadio, setValueRadio] = useState('allDay');
    const [dateSSO, setDateSSo] = useState(defaultDateSSO);
    const [paramPage, setParamPage] = useState({
        page: 1,
        size: 10
    });
    const [listSSO, setListSSO] = useState([]);
    // const [listSSOEachPage, setListSSOEachPage] = useState([]);
    const [sumSSO, setSumSSO] = useState();
    const [total, setTotal] = useState();

    const dataItemsPaper = dataPaper?.filter(
        (item) => item.papersType !== 'TONG'
    );

    const dataSumPaper = dataPaper?.find((item) => item.papersType === 'TONG');

    const detailSearch = activeTable?.vneidReportPapersDetails?.filter(
        (item) => item.status === activeStatus
    );

    const loadLazyData = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_REPORT_API_URL}/dashboard`, {
                headers
            })
            .then((res) => {
                if (res.status === 200 && res.data) {
                    setDataReport(res.data);
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    const getPaperIntergrate = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_REPORT_API_URL}/dashboard/papers`, {
                headers
            })
            .then((res) => {
                if (res.status === 200 && res.data) {
                    setDataPaper(res.data);
                    setActiveTable(res.data[0]);
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    // const handleScroll = (e) => {
    //     const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    //     if (listSSOEachPage.length < paramPage.size) {
    //         return;
    //     } else if (bottom) {
    //         setParamPage({ ...paramPage, page: paramPage.page + 1 });
    //     }
    // };

    const getListSSO = () => {
        setLoading(true);
        const fromDate = moment(dateSSO.fromDate).format('DD-MM-YYYY');
        const endDate = moment(dateSSO.endDate).format('DD-MM-YYYY');
        axios
            .get(
                valueRadio === 'allDay'
                    ? `${process.env.REACT_APP_REPORT_API_URL}/dashboard/getListSSO?page=${paramPage.page}&size=${paramPage.size}`
                    : `${process.env.REACT_APP_REPORT_API_URL}/dashboard/getListSSO?toDate=${endDate}&fromDate=${fromDate}&page=${paramPage.page}&size=${paramPage.size}`,
                { headers }
            )
            .then((res) => {
                if (res.status === 200 && res.data.length > 0) {
                    setListSSO(res.data);
                    setTotal(res.data[0].toltalRecord);
                } else {
                    setListSSO([]);
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    const getSumSSO = () => {
        setLoading(true);
        const fromDate = moment(dateSSO.fromDate).format('DD-MM-YYYY');
        const endDate = moment(dateSSO.endDate).format('DD-MM-YYYY');
        axios
            .get(
                valueRadio === 'allDay'
                    ? `${process.env.REACT_APP_REPORT_API_URL}/dashboard/totalSSO`
                    : `${process.env.REACT_APP_REPORT_API_URL}/dashboard/totalSSO?toDate=${endDate}&fromDate=${fromDate}`,
                { headers }
            )
            .then((res) => {
                if (res.status === 200) {
                    setSumSSO(res.data);
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    };

    const renderMuc1 = () => {
        switch (muc1) {
            case 1:
                return numberWithCommas(dataReport?.accLv1WaitingActiv);
            case 2:
                return numberWithCommas(dataReport?.accLv1IsActiv);
            case 3:
                return numberWithCommas(dataReport?.accLv1TemporarilyLocked);
            case 4:
                return numberWithCommas(dataReport?.accLv1PermanentlyLocked);
            default:
                return null;
        }
    };
    const renderMuc2 = () => {
        switch (muc2) {
            case 1:
                return numberWithCommas(dataReport?.accLv2WaitingActiv);
            case 2:
                return numberWithCommas(dataReport?.accLv2IsActiv);
            case 3:
                return numberWithCommas(dataReport?.accLv2TemporarilyLocked);
            case 4:
                return numberWithCommas(dataReport?.accLv2PermanentlyLocked);
            default:
                return null;
        }
    };

    //! useEffect
    useEffect(() => {
        loadLazyData();
        getPaperIntergrate();
    }, []);

    useEffect(() => {
        getListSSO();
    }, [paramPage]);

    useEffect(() => {
        setDateSSo(defaultDateSSO);
        getSumSSO();
        getListSSO();
    }, [valueRadio]);
    useEffect(() => {
        const data = {
            labels: ['Chưa tra cứu', 'Tra cứu lỗi', 'Tra cứu thành công'],
            datasets: [
                {
                    label: 'Tổng',
                    data: [
                        activeTable?.searchNotTotal,
                        activeTable?.searchErrorTotal,
                        activeTable?.searchSuccessTotal
                    ],
                    backgroundColor: [
                        'rgba(250, 204, 64, 1)',
                        'rgba(215, 25, 31, 1)',
                        'rgba(80, 223, 178, 1)'
                    ],
                    borderColor: [
                        'rgba(250, 204, 64, 1)',
                        'rgba(215, 25, 31, 1)',
                        'rgba(80, 223, 178, 1)'
                    ],
                    borderRadius: 16,
                    borderWidth: 1
                }
            ]
        };
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            },
            onClick: (event, elements) => {
                setActiveStatus(elements[0]?.index);
            }
        };

        setChartData(data);
        setChartOptions(options);
    }, [activeTable]);
    const handleChangePage = (first) => {
        if (first.rows !== paramPage.size) {
            setParamPage({ page: 1, size: first.rows });
        } else {
            setParamPage({ ...paramPage, page: first.page + 1 });
        }
    };
    //! render
    return (
        <div className="grid crud">
            <Toast ref={toast} />
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            {/* <h4 className="text-center font-bold">{t("register.title")?.toUpperCase()}</h4> */}
                            <h4 className="font-bold">
                                Dashboard thống kê số liệu vùng ngoài Hệ thống
                                định danh và xác thực điện tử
                            </h4>
                        </div>
                        <div className="col-12 lg:col-4 xl:col-3">
                            {/* <div className="card mb-0"> */}

                            <Card>
                                <div className="block text-500 font-bold text-xl">
                                    {t('Thống kê hôm nay')}
                                </div>
                                <div className="text-500 font-bold text-xs">
                                    {moment(new Date()).format('DD/MM/YYYY')}
                                </div>
                                <div className="card mt-3">
                                    <div className="block font-bold text-xs">
                                        {t('SMS kích hoạt mức 1')}
                                    </div>
                                    <div
                                        className="font-bold text-xl"
                                        style={{ color: '#21234A' }}>
                                        {numberWithCommas(
                                            dataReport?.daillySmsActivAccSuccessLv1 +
                                                dataReport?.daillySmsActivAccFailLv1
                                        )}
                                    </div>
                                    <div className="flex justify-content-between mb-3">
                                        <div>
                                            <div className="text-xs">
                                                Thành công
                                            </div>
                                            <div
                                                className="font-bold text-lg"
                                                style={{ color: '#35DC94' }}>
                                                {numberWithCommas(
                                                    dataReport?.daillySmsActivAccSuccessLv1
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="text-xs">
                                                Chưa gửi được
                                            </div>
                                            <div
                                                className="font-bold text-lg"
                                                style={{ color: '#D71920' }}>
                                                {numberWithCommas(
                                                    dataReport?.daillySmsActivAccFailLv1
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mt-3">
                                    <div className="block font-bold text-xs">
                                        {t('SMS kích hoạt mức 2')}
                                    </div>
                                    <div
                                        className="font-bold text-xl"
                                        style={{ color: '#21234A' }}>
                                        {numberWithCommas(
                                            dataReport?.daillySmsActivAccSuccessLv2 +
                                                dataReport?.daillySmsActivAccFailLv2
                                        )}
                                    </div>
                                    <div className="flex justify-content-between mb-3">
                                        <div>
                                            <div className="text-xs">
                                                Thành công
                                            </div>
                                            <div
                                                className="font-bold text-lg"
                                                style={{ color: '#35DC94' }}>
                                                {numberWithCommas(
                                                    dataReport?.daillySmsActivAccSuccessLv2
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="text-xs">
                                                Chưa gửi được
                                            </div>
                                            <div
                                                className="font-bold text-lg"
                                                style={{ color: '#D71920' }}>
                                                {numberWithCommas(
                                                    dataReport?.daillySmsActivAccFailLv2
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mt-3">
                                    <div className="flex justify-content-between mb-3">
                                        <div className=" ">
                                            <div className="block font-bold text-xs">
                                                {t(
                                                    'Tài khoản mức 1 kích hoạt thành công'
                                                )}
                                            </div>
                                            <div
                                                className="font-bold text-xl"
                                                style={{ color: '#21234A' }}>
                                                {numberWithCommas(
                                                    dataReport?.daillyAccActivSuccessLv1
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            className="text-center"
                                            style={{ width: '35%' }}>
                                            {dataReport?.compareTotalSmsActivAccLv1 >=
                                            0 ? (
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/green_wave.svg`}
                                                    alt=""
                                                />
                                            ) : (
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/red_wave.svg`}
                                                    alt=""
                                                />
                                            )}
                                            <div
                                                style={{
                                                    color:
                                                        dataReport?.compareTotalSmsActivAccLv1 >=
                                                        0
                                                            ? '#35DC94'
                                                            : '#D71920',
                                                    margin: '8px 0px'
                                                }}>
                                                {
                                                    dataReport?.compareTotalSmsActivAccLv1
                                                }
                                                %{' '}
                                                {dataReport?.compareTotalSmsActivAccLv1 >=
                                                0 ? (
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/layout/images/green_arrow_up.svg`}
                                                        alt=""
                                                    />
                                                ) : (
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/layout/images/red_arrow_down.svg`}
                                                        alt=""
                                                    />
                                                )}
                                            </div>
                                            <div
                                                className="font-medium"
                                                style={{
                                                    fontSize: 10,
                                                    color: '#21234A'
                                                }}>
                                                So với hôm qua
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mt-3">
                                    <div className="flex justify-content-between mb-3">
                                        <div className="">
                                            <div className="block font-bold text-xs">
                                                {t(
                                                    'Tài khoản mức 2 kích hoạt thành công'
                                                )}
                                            </div>
                                            <div
                                                className="font-bold text-xl"
                                                style={{ color: '#21234A' }}>
                                                {numberWithCommas(
                                                    dataReport?.daillyAccActivSuccessLv2
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            className="text-center"
                                            style={{ width: '35%' }}>
                                            {dataReport?.compareTotalSmsActivAccLv2 >=
                                            0 ? (
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/green_wave.svg`}
                                                    alt=""
                                                />
                                            ) : (
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/red_wave.svg`}
                                                    alt=""
                                                />
                                            )}
                                            <div
                                                style={{
                                                    color:
                                                        dataReport?.compareTotalSmsActivAccLv2 >=
                                                        0
                                                            ? '#35DC94'
                                                            : '#D71920',
                                                    margin: '8px 0px'
                                                }}>
                                                {
                                                    dataReport?.compareTotalSmsActivAccLv2
                                                }
                                                %{' '}
                                                {dataReport?.compareTotalSmsActivAccLv2 >=
                                                0 ? (
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/layout/images/green_arrow_up.svg`}
                                                        alt=""
                                                    />
                                                ) : (
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/layout/images/red_arrow_down.svg`}
                                                        alt=""
                                                    />
                                                )}
                                            </div>
                                            <div
                                                className="font-medium"
                                                style={{
                                                    fontSize: 10,
                                                    color: '#21234A'
                                                }}>
                                                So với hôm qua
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="block text-500 font-bold text-xl">
                                    {t('Tài khoản vùng ngoài')}
                                </div>

                                <div className="flex justify-content-between align-items-center mb-3">
                                    <div
                                        className="font-bold "
                                        style={{
                                            fontSize: 26,
                                            color: '#404040'
                                        }}>
                                        {numberWithCommas(
                                            dataReport?.accLv0 +
                                                dataReport?.accLv1 +
                                                dataReport?.accLv2
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div
                                        className="font-semibold text-sm"
                                        style={{
                                            color: '#404040',
                                            lineHeight: '32px'
                                        }}>
                                        Mức 0
                                    </div>
                                    <div
                                        className="font-normal text-base"
                                        style={{ color: '#404040' }}>
                                        {numberWithCommas(dataReport?.accLv0)}
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="font-semibold text-sm mr-3"
                                            style={{ color: '#404040' }}>
                                            Mức 1
                                        </div>
                                        <Dropdown
                                            className="my-3"
                                            value={muc1}
                                            style={{ flex: 1 }}
                                            options={option}
                                            onChange={(e) =>
                                                setMuc1(e.value)
                                            }></Dropdown>
                                    </div>
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="font-normal text-base"
                                            style={{ color: '#404040' }}>
                                            {numberWithCommas(
                                                dataReport?.accLv1
                                            )}
                                        </div>
                                        <div
                                            className="font-normal text-base"
                                            style={{ color: '#404040' }}>
                                            {renderMuc1()}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="font-semibold text-sm mr-3"
                                            style={{ color: '#404040' }}>
                                            Mức 2
                                        </div>
                                        <Dropdown
                                            className="my-3"
                                            value={muc2}
                                            style={{ flex: 1 }}
                                            options={option}
                                            onChange={(e) =>
                                                setMuc2(e.value)
                                            }></Dropdown>
                                    </div>
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="font-normal text-base"
                                            style={{ color: '#404040' }}>
                                            {numberWithCommas(
                                                dataReport?.accLv2
                                            )}
                                        </div>
                                        <div
                                            className="font-normal text-base"
                                            style={{ color: '#404040' }}>
                                            {renderMuc2()}
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        {/* </div> */}
                        <div
                            className="col-12 lg:col-8 xl:col-9"
                            style={{ height: '100%' }}>
                            {/* <div className="card mb-0"> */}
                            <Card>
                                <div>
                                    <h4 className="font-bold">
                                        Thống kê tổng hợp
                                    </h4>

                                    <div className="grid">
                                        <div className="col-12 lg:col-6 xl:col-3">
                                            <div className="flex align-items-center">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/SMS1.svg`}
                                                    alt="SMS mức 1"
                                                />
                                                <div className="ml-3">
                                                    <div className="font-bold text-sm">
                                                        SMS kích hoạt mức 1
                                                    </div>
                                                    <div className="font-medium text-base">
                                                        {numberWithCommas(
                                                            dataReport?.totalSmsActivAccLv1
                                                        )}{' '}
                                                        SMS
                                                    </div>
                                                    <i
                                                        className="font-medium text-xs"
                                                        style={{
                                                            color: '#D71920'
                                                        }}>
                                                        {numberWithCommas(
                                                            dataReport?.totalSmsActivAccFailLv1
                                                        )}{' '}
                                                        Chưa gửi được
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-6 xl:col-3">
                                            <div className="flex align-items-center">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/SMS2.svg`}
                                                    alt="SMS mức 2"
                                                />
                                                <div className="ml-3">
                                                    <div className="font-bold text-sm">
                                                        SMS kích hoạt mức 2
                                                    </div>
                                                    <div className="font-medium text-base">
                                                        {numberWithCommas(
                                                            dataReport?.totalSmsActivAccLv2
                                                        )}{' '}
                                                        SMS
                                                    </div>
                                                    <i
                                                        className="font-medium text-xs"
                                                        style={{
                                                            color: '#D71920'
                                                        }}>
                                                        {numberWithCommas(
                                                            dataReport?.totalSmsActivAccFailLv2
                                                        )}{' '}
                                                        Chưa gửi được
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-6 xl:col-3">
                                            <div className="flex align-items-center">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/TBLT.svg`}
                                                    alt="TBLT"
                                                />
                                                <div className="ml-3">
                                                    <div className="font-bold text-sm">
                                                        Thông báo lưu trú
                                                    </div>
                                                    <div className="font-medium text-base">
                                                        {numberWithCommas(
                                                            dataReport?.totalStayNotifications
                                                        )}{' '}
                                                        tin
                                                    </div>
                                                    <div className="font-medium text-xs">
                                                        {numberWithCommas(
                                                            dataReport?.totalPeopleStayNotifi
                                                        )}{' '}
                                                        người thông báo
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-6 xl:col-3">
                                            <div className="flex align-items-center">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/layout/images/KNPA.svg`}
                                                    alt="KNPA"
                                                />
                                                <div className="ml-3">
                                                    <div className="font-bold text-sm">
                                                        Kiến nghị phản ánh
                                                    </div>
                                                    <div className="font-medium text-base">
                                                        {numberWithCommas(
                                                            dataReport?.totalDenounceReport
                                                        )}{' '}
                                                        tin
                                                    </div>
                                                    <div className="font-medium text-xs">
                                                        {numberWithCommas(
                                                            dataReport?.totalPeopleDenounceReport
                                                        )}{' '}
                                                        người thông báo
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className="col-12 xl:col-6">
                                        <h4 className="font-bold mt-5">
                                            Thống kê SSO
                                        </h4>
                                        <div>
                                            <div className="flex align-items-center m-1">
                                                <RadioButton
                                                    value="allDay"
                                                    checked={
                                                        valueRadio === 'allDay'
                                                    }
                                                    onChange={async (e) => {
                                                        setParamPage({
                                                            ...paramPage,
                                                            page: 1
                                                        });
                                                        setValueRadio(e.value);
                                                    }}
                                                />
                                                <label
                                                    htmlFor="ingredient1"
                                                    className="mx-1 font-bold text-sm">
                                                    Tất cả ngày
                                                </label>
                                            </div>
                                            <div className="flex align-items-center m-1">
                                                <RadioButton
                                                    value="eachDay"
                                                    checked={
                                                        valueRadio === 'eachDay'
                                                    }
                                                    onChange={async (e) => {
                                                        setParamPage({
                                                            ...paramPage,
                                                            page: 1
                                                        });
                                                        setValueRadio(e.value);
                                                    }}
                                                />
                                                <label
                                                    htmlFor="ingredient2"
                                                    className="mx-1 font-bold text-sm">
                                                    Thống kê theo ngày
                                                </label>
                                                {valueRadio === 'eachDay' && (
                                                    <div className="flex mx-2">
                                                        <div className="flex align-items-center mx-1 ">
                                                            <Calendar
                                                                style={{
                                                                    width: '100px',
                                                                    height: '28px'
                                                                }}
                                                                value={
                                                                    dateSSO.fromDate
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    const fromDate =
                                                                        e.value;
                                                                    setDateSSo({
                                                                        ...dateSSO,
                                                                        fromDate:
                                                                            fromDate
                                                                    });
                                                                }}
                                                                name="fromDate"
                                                                dateFormat={
                                                                    dateFormat1
                                                                }
                                                                maxDate={
                                                                    dateSSO.endDate
                                                                }
                                                            />
                                                        </div>
                                                        <div className="flex align-items-center mx-1">
                                                            <Calendar
                                                                style={{
                                                                    width: '100px',
                                                                    height: '28px'
                                                                }}
                                                                value={
                                                                    dateSSO.endDate
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    const endDate =
                                                                        e.value;
                                                                    setDateSSo({
                                                                        ...dateSSO,
                                                                        endDate:
                                                                            endDate
                                                                    });
                                                                }}
                                                                name="endDate"
                                                                dateFormat={
                                                                    dateFormat1
                                                                }
                                                            />
                                                        </div>
                                                        <div
                                                            className="flex align-items-center mx-1 pi pi-search p-2"
                                                            style={{
                                                                background:
                                                                    '#4f46ba',
                                                                color: 'white',
                                                                cursor: 'pointer',
                                                                borderRadius:
                                                                    '4px'
                                                            }}
                                                            onClick={() => {
                                                                if (
                                                                    dateSSO.fromDate &&
                                                                    dateSSO.endDate
                                                                ) {
                                                                    const fromDate =
                                                                        moment(
                                                                            dateSSO.fromDate,
                                                                            'DD-MM-YYYY'
                                                                        );
                                                                    const endDate =
                                                                        moment(
                                                                            dateSSO.endDate,
                                                                            'DD-MM-YYYY'
                                                                        );
                                                                    const differenceInDays =
                                                                        endDate.diff(
                                                                            fromDate,
                                                                            'days'
                                                                        );
                                                                    if (
                                                                        differenceInDays >
                                                                        7
                                                                    ) {
                                                                        toast.current.show(
                                                                            {
                                                                                severity:
                                                                                    'error',
                                                                                summary:
                                                                                    t(
                                                                                        'info',
                                                                                        {
                                                                                            ns: 'common'
                                                                                        }
                                                                                    ),
                                                                                detail: t(
                                                                                    'register.limitDateSSO'
                                                                                ),
                                                                                life: 3000
                                                                            }
                                                                        );
                                                                    } else {
                                                                        setParamPage(
                                                                            {
                                                                                ...paramPage,
                                                                                page: 1
                                                                            }
                                                                        );
                                                                        getSumSSO();
                                                                        // getListSSO();
                                                                    }
                                                                } else {
                                                                    toast.current.show(
                                                                        {
                                                                            severity:
                                                                                'error',
                                                                            summary:
                                                                                t(
                                                                                    'info',
                                                                                    {
                                                                                        ns: 'common'
                                                                                    }
                                                                                ),
                                                                            detail: t(
                                                                                'register.requiredDateSSO'
                                                                            ),
                                                                            life: 3000
                                                                        }
                                                                    );
                                                                }
                                                            }}></div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="text-900 font-medium text-xl">
                                            <div
                                                className="grid"
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'end'
                                                }}>
                                                {/* <ScrollPanel className="col-12 lg:col-12 custombar" style={{ height: "368px" }} onScrollCapture={handleScroll}> */}
                                                <ScrollPanel
                                                    className="col-12 lg:col-12 custombar"
                                                    style={{ height: '630px' }}>
                                                    <table
                                                        style={{
                                                            width: '100%'
                                                        }}>
                                                        <thead>
                                                            <tr
                                                                style={{
                                                                    position:
                                                                        'sticky',
                                                                    top: 0,
                                                                    background:
                                                                        '#fff'
                                                                }}>
                                                                <th
                                                                    className="font-medium text-sm"
                                                                    style={{
                                                                        textAlign:
                                                                            'start',
                                                                        color: '#A3AED0'
                                                                    }}>
                                                                    Đơn vị
                                                                </th>
                                                                <th
                                                                    className="font-medium text-sm"
                                                                    style={{
                                                                        textAlign:
                                                                            'end',
                                                                        color: '#A3AED0'
                                                                    }}>
                                                                    Số lượt đăng
                                                                    nhập
                                                                </th>
                                                                <th
                                                                    className="font-medium text-sm"
                                                                    style={{
                                                                        textAlign:
                                                                            'end',
                                                                        color: '#A3AED0'
                                                                    }}>
                                                                    Số lượng
                                                                    công dân
                                                                </th>
                                                            </tr>
                                                            <tr
                                                                style={{
                                                                    position:
                                                                        'sticky',
                                                                    top: 17,
                                                                    background:
                                                                        '#fff',
                                                                    height: 49
                                                                }}>
                                                                <th
                                                                    className="font-medium font-bold text-sm"
                                                                    style={{
                                                                        textAlign:
                                                                            'start',
                                                                        color: 'red'
                                                                    }}>
                                                                    Tất cả đơn
                                                                    vị
                                                                </th>
                                                                <th
                                                                    className="font-medium font-bold text-sm"
                                                                    style={{
                                                                        textAlign:
                                                                            'end',
                                                                        color: 'red'
                                                                    }}>
                                                                    {numberWithCommas(
                                                                        sumSSO?.totalLogin.toString()
                                                                    )}
                                                                </th>
                                                                <th
                                                                    className="font-medium font-bold text-sm"
                                                                    style={{
                                                                        textAlign:
                                                                            'end',
                                                                        color: 'red'
                                                                    }}>
                                                                    {numberWithCommas(
                                                                        sumSSO?.citizenLogin.toString()
                                                                    )}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        {listSSO?.map(
                                                            (item) => {
                                                                return (
                                                                    <tr
                                                                        key={
                                                                            item.id
                                                                        }
                                                                        style={{
                                                                            height: 49,
                                                                            cursor: 'pointer'
                                                                        }}>
                                                                        <td
                                                                            className="font-bold text-sm"
                                                                            style={{
                                                                                color: '#2B3674'
                                                                            }}>
                                                                            {
                                                                                item.unitName
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            className="font-medium text-sm"
                                                                            style={{
                                                                                textAlign:
                                                                                    'end',
                                                                                color: '#2B3674'
                                                                            }}>
                                                                            {numberWithCommas(
                                                                                item.totalLogin.toString()
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            className="font-medium text-sm"
                                                                            style={{
                                                                                textAlign:
                                                                                    'end',
                                                                                color: '#2B3674'
                                                                            }}>
                                                                            {numberWithCommas(
                                                                                item.citizenLogin.toString()
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }
                                                        )}
                                                    </table>
                                                </ScrollPanel>
                                                <Paginator
                                                    first={
                                                        paramPage.page *
                                                            paramPage.size -
                                                        paramPage.size
                                                    }
                                                    rows={paramPage.size}
                                                    totalRecords={total}
                                                    rowsPerPageOptions={[
                                                        10, 50, 100
                                                    ]}
                                                    onPageChange={
                                                        handleChangePage
                                                    }></Paginator>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 xl:col-6">
                                        <h4 className="font-bold mt-5">
                                            Thông tin yêu cầu tích hợp giấy tờ
                                        </h4>
                                        <div className="text-900 font-medium text-xl">
                                            <div className="grid">
                                                <ScrollPanel
                                                    className="col-12 lg:col-12  custombar"
                                                    style={{ height: '630px' }}>
                                                    <table
                                                        style={{
                                                            width: '100%',
                                                            borderSpacing: 0
                                                        }}>
                                                        <tr
                                                            style={{
                                                                position:
                                                                    'sticky',
                                                                top: 0,
                                                                background:
                                                                    '#fff'
                                                            }}>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'start',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Loại giấy tờ
                                                            </th>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Tổng số
                                                            </th>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                VNeID
                                                            </th>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Web
                                                            </th>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Thu nhận
                                                            </th>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                position:
                                                                    'sticky',
                                                                top: 32,
                                                                background:
                                                                    '#fff',
                                                                height: 49
                                                            }}>
                                                            <td
                                                                className="font-medium font-bold text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'start',
                                                                    color: 'red'
                                                                }}>
                                                                Tất cả giấy tờ
                                                            </td>
                                                            <td
                                                                className="font-medium font-bold text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: 'red'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataSumPaper?.total
                                                                )}
                                                            </td>
                                                            <td
                                                                className="font-medium font-bold text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: 'red'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataSumPaper?.appTotal
                                                                )}
                                                            </td>
                                                            <td
                                                                className="font-medium font-bold text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: 'red'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataSumPaper?.webTotal
                                                                )}
                                                            </td>
                                                            <td
                                                                className="font-medium font-bold text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: 'red'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataSumPaper?.xlhsTotal
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tbody>
                                                            {dataItemsPaper?.map(
                                                                (item) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                item.id
                                                                            }
                                                                            style={{
                                                                                height: 49,
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={() =>
                                                                                setActiveTable(
                                                                                    item
                                                                                )
                                                                            }
                                                                            className={
                                                                                activeTable?.papersType ===
                                                                                item.papersType
                                                                                    ? 'active-table'
                                                                                    : ''
                                                                            }>
                                                                            <td
                                                                                className="font-bold text-sm"
                                                                                style={{
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {
                                                                                    TypePaper[
                                                                                        item
                                                                                            .papersType
                                                                                    ]
                                                                                }
                                                                            </td>
                                                                            <td
                                                                                className="font-medium text-sm"
                                                                                style={{
                                                                                    textAlign:
                                                                                        'end',
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {numberWithCommas(
                                                                                    item.total
                                                                                )}
                                                                            </td>
                                                                            <td
                                                                                className="font-medium text-sm"
                                                                                style={{
                                                                                    textAlign:
                                                                                        'end',
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {numberWithCommas(
                                                                                    item.app
                                                                                )}
                                                                            </td>
                                                                            <td
                                                                                className="font-medium text-sm"
                                                                                style={{
                                                                                    textAlign:
                                                                                        'end',
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {numberWithCommas(
                                                                                    item.web
                                                                                )}
                                                                            </td>
                                                                            <td
                                                                                className="font-medium text-sm"
                                                                                style={{
                                                                                    textAlign:
                                                                                        'end',
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {numberWithCommas(
                                                                                    item.xlhs
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </ScrollPanel>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="grid"
                                    style={{ height: '100%' }}>
                                    <div className="col-12 xl:col-6">
                                        <h4 className="font-bold mt-5">
                                            Trạng thái yêu cầu:{' '}
                                            {TypePaper[activeTable?.papersType]}
                                        </h4>
                                        <Chart
                                            type="bar"
                                            data={chartData}
                                            options={chartOptions}
                                        />
                                    </div>
                                    <div className="col-12 xl:col-6">
                                        <h4 className="font-bold mt-5">
                                            Chi tiết tình trạng tra cứu:{' '}
                                            {TypePaper[activeTable?.papersType]}
                                        </h4>
                                        <div className="text-900 font-medium text-xl">
                                            <div className="grid">
                                                <ScrollPanel
                                                    className="col-12 lg:col-12  custombar"
                                                    style={{ height: '368px' }}>
                                                    <table
                                                        style={{
                                                            width: '100%',
                                                            borderSpacing: 0
                                                        }}>
                                                        <tr
                                                            style={{
                                                                position:
                                                                    'sticky',
                                                                top: 0,
                                                                background:
                                                                    '#fff'
                                                            }}>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'start',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Tình trạng
                                                            </th>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Số lượng
                                                            </th>
                                                        </tr>
                                                        <tbody>
                                                            {detailSearch?.map(
                                                                (item) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                item.id
                                                                            }
                                                                            style={{
                                                                                height: 49,
                                                                                cursor: 'pointer'
                                                                            }}>
                                                                            <td
                                                                                className="font-bold text-sm"
                                                                                style={{
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {numberWithCommas(
                                                                                    item.statusName
                                                                                )}
                                                                            </td>
                                                                            <td
                                                                                className="font-medium text-sm"
                                                                                style={{
                                                                                    textAlign:
                                                                                        'end',
                                                                                    color: '#2B3674'
                                                                                }}>
                                                                                {numberWithCommas(
                                                                                    item.total
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </ScrollPanel>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className="col-12 xl:col-6">
                                        <h4 className="font-bold mt-5">
                                            Thông tin tiêm chủng theo loại
                                        </h4>
                                        <div className="text-900 font-medium text-xl">
                                            <div className="grid">
                                                <ScrollPanel
                                                    className="col-12 lg:col-12 custombar"
                                                    style={{ height: '368px' }}>
                                                    {/* <ScrollPanel style={{ width: "100%", height: "150px" }} className="custombar"> */}

                                                    <table
                                                        style={{
                                                            width: '100%'
                                                        }}>
                                                        <tr
                                                            style={{
                                                                position:
                                                                    'sticky',
                                                                top: 0,
                                                                background:
                                                                    '#fff'
                                                            }}>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'start',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Loại vaccine
                                                            </th>
                                                            <th
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#A3AED0'
                                                                }}>
                                                                Số mũi tiêm
                                                            </th>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                height: 49
                                                            }}>
                                                            <td
                                                                className="font-bold text-sm"
                                                                style={{
                                                                    color: '#2B3674'
                                                                }}>
                                                                Astrazeneca
                                                            </td>
                                                            <td
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#2B3674'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataReport?.vaccinAstrazeneca
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                height: 49
                                                            }}>
                                                            <td
                                                                className="font-bold text-sm"
                                                                style={{
                                                                    color: '#2B3674'
                                                                }}>
                                                                Pfizer
                                                            </td>
                                                            <td
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#2B3674'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataReport?.vaccinPlizer
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                height: 49
                                                            }}>
                                                            <td
                                                                className="font-bold text-sm"
                                                                style={{
                                                                    color: '#2B3674'
                                                                }}>
                                                                Verocell
                                                            </td>
                                                            <td
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#2B3674'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataReport?.vaccinVerocell
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                height: 49
                                                            }}>
                                                            <td
                                                                className="font-bold text-sm"
                                                                style={{
                                                                    color: '#2B3674'
                                                                }}>
                                                                Mordenar
                                                            </td>
                                                            <td
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#2B3674'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataReport?.vaccinMordenar
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                height: 49
                                                            }}>
                                                            <td
                                                                className="font-bold text-sm"
                                                                style={{
                                                                    color: '#2B3674'
                                                                }}>
                                                                SpikeVax
                                                            </td>
                                                            <td
                                                                className="font-medium text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '#2B3674'
                                                                }}>
                                                                {numberWithCommas(
                                                                    dataReport?.vaccinSpikevax
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                height: 49
                                                            }}>
                                                            <th />
                                                            <th
                                                                className="font-bold text-sm"
                                                                style={{
                                                                    textAlign:
                                                                        'end',
                                                                    color: '##343434'
                                                                }}>
                                                                Tổng số:{' '}
                                                                {numberWithCommas(
                                                                    dataReport?.vaccinAstrazeneca +
                                                                        dataReport?.vaccinPlizer +
                                                                        dataReport?.vaccinVerocell +
                                                                        dataReport?.vaccinMordenar +
                                                                        dataReport?.vaccinSpikevax
                                                                )}
                                                            </th>
                                                        </tr>
                                                    </table>
                                                </ScrollPanel>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ThongKeSoLieu;
